import React, { FC } from "react";
import { Spin } from "antd";
import formatNumber from "../../lib/utils/formatNumber";

interface ISpanNumberFormat {
  amount: number | string;
  fractSize?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12; // для запрета ввода отриацательного размера дробной части
  loading?: boolean;
  style?: Record<string, string>;
}

const SpanNumberFormat = ({
  amount,
  fractSize = 2,
  loading = false,
  style = {},
}: ISpanNumberFormat) => {
  if (Number.isNaN(Number(amount))) return null; // проверка для подключений в js файлах
  return loading ? (
    <Spin spinning />
  ) : (
    <span style={{ whiteSpace: "nowrap", ...style }}>{formatNumber(amount, fractSize)}</span>
  );
};

export default SpanNumberFormat;
